import { render, staticRenderFns } from "./FacturasPendientesView.vue?vue&type=template&id=bd29b988"
import script from "./FacturasPendientesView.vue?vue&type=script&lang=js"
export * from "./FacturasPendientesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports